@let label = labelSg();
@let typedValue = typedValueSg();
@let intrinsicTypedValue = intrinsicTypedValueSg();
@let referenceTypedValue = referenceTypedValueSg();
@let multiReferenceTypedValue = multiReferenceTypedValueSg();
@let enumTypedValue = enumTypedValueSg();
@let inlineEnumTypedValue = inlineEnumTypedValueSg();
@let structureTypedValue = structureTypedValueSg();
@let inlineStructureTypedValue = inlineStructureTypedValueSg();
@let filesTypedValue = filesTypedValueSg();

@if (intrinsicTypedValue) {
  <atn-intrinsic-input
    [label]="label"
    [typedValue]="intrinsicTypedValue"
    (typedValueChange)="typedValueSg.set($event)"
  />
} @else if (referenceTypedValue) {
  <!-- NOTE: Using 'type' instead of 'inferredType' here as 'inferredType' is a
  fallback that defaults to intrinsic type, which isn't applicable in this case
  -->
  <atn-reference-input
    [label]="label"
    [value]="referenceTypedValue.value"
    [type]="referenceTypedValue.type"
    [required]="requiredSg()"
    (valueChange)="setReferenceValue(referenceTypedValue.type, $event)"
  />
} @else if (multiReferenceTypedValue) {
  <atn-multi-reference-input
    [value]="multiReferenceTypedValue.value"
    [type]="multiReferenceTypedValue.type"
    (valueChange)="
      typedValueSg.set({ type: multiReferenceTypedValue.type, value: $event })
    "
  />
} @else if (enumTypedValue) {
  <!-- NOTE: Using 'type' instead of 'inferredType' here as 'inferredType' is a
  fallback that defaults to intrinsic type, which isn't applicable in this case
  -->
  <atn-enum-input
    [label]="label"
    [value]="enumTypedValue.value"
    [enum]="enumTypedValue.type"
    (valueChange)="
      typedValueSg.set({ type: enumTypedValue.type, value: $event })
    "
  />
} @else if (inlineEnumTypedValue) {
  <atn-inline-enum-input
    [label]="label"
    [value]="inlineEnumTypedValue.value"
    [enum]="inlineEnumTypedValue.type"
    [required]="requiredSg()"
    (valueChange)="
      typedValueSg.set({ type: inlineEnumTypedValue.type, value: $event })
    "
  />
} @else if (structureTypedValue) {
  <b>{{ label }}</b> <br />
  TODO: structure
} @else if (inlineStructureTypedValue) {
  <b>{{ label }}</b> <br />
  TODO: inline structure
} @else if (filesTypedValue) {
  <atn-files-input
    [label]="label"
    [type]="filesTypedValue.type"
    [value]="filesTypedValue.value"
    [required]="requiredSg()"
    [documentKey]="documentKeySg()"
    [recordTarget]="recordTargetSg()"
    (valueChange)="
      typedValueSg.set({ type: filesTypedValue.type, value: $event })
    "
  />
} @else {
  <!-- NOTE: We provide information about unsupported type here. This is an edge
       case (99% of types should be handled above), but we handle it gracefully
       to help developers identify the issue. -->
  <b>{{ label }}</b> <br />
  Type
  <span style="font-style: italic"
    ><b>{{ typedValue.type | json }} </b></span
  >
  not supported.
}
